import { Typography } from "@mui/material";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import NewLink from "../Link/NewLink.tsx";

export default function Footer() {
  return (
    <>
      {
        <Box component="footer" sx={{ py: 6 }}>
          <Container maxWidth="lg">
            <Typography variant="body2" color="textSecondary" align="center">
              © {new Date().getFullYear()} GeoStrat
            </Typography>
            <Typography variant="body2" color="textSecondary" align="center">
              <NewLink href="/privacy-policy" color="inherit">
                Privacy Policy
              </NewLink>
              {" | "}
              <NewLink href="/terms-of-service" color="inherit">
                Terms of Service
              </NewLink>
            </Typography>
          </Container>
        </Box>
      }
    </>
  );
}
